"use client";
import React, { useState, useEffect } from "react";
import style from "@/app/style/state.module.css";
import Image from "next/image";
import map from "../../../public/updated-home/contact/map.svg";
import CustomInputField from "@/app/componenets/CustomInputField";
import { validateEmail } from "@/utilities/utilis";
import MuiPhoneNumber from "mui-phone-number";
import axios from "axios";
import config from "../../config";
import Modal from "react-bootstrap/Modal";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { initialStoreState } from "@/initialState";
import { UpdateStore } from "../../StoreContext";
import { useRouter } from "next/navigation";
import ReCAPTCHA from "react-google-recaptcha";

const capaptha = config.recaptchaLink;

console.log(capaptha, "capaptha");

function Homepage() {
  const home = [
    {
      image: "conatctus",
    },
  ];

  const updateStore = UpdateStore();

  const [continueClicked, setContinueClicked] = useState(false);
  const [capVal, SetCapVal] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const [customerValidation, setCustomerValidation] = useState({
    firstName: { InValid: false, text: "" },
    lastName: { InValid: false, text: "" },
    email: { InValid: false, text: "" },
    phone: { InValid: false, text: "" },
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Token ko temporarily save karo
      const token = localStorage.getItem("token");

      // localStorage ko clear karo
      localStorage.clear();

      // Token ko wapas set karo
      if (token) {
        localStorage.setItem("token", token);
      }
    }
    updateStore(initialStoreState);
  }, []);

  useEffect(() => {
    if (continueClicked) {
      checkValidation();
    }
  }, [continueClicked, formData]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleChangePhone = (value) => {
    setFormData((prevState) => ({
      ...prevState,
      phone: value,
    }));
  };

  const isValidPhoneNumber = (value) => {
    // Basic validation: Check if the value is a string and length
    return typeof value === "string" && value.length > 10;
    // return typeof value === "string" && value.length > 13;
  };

  const checkValidation = () => {
    let valid = true;
    const customerMandatoryFields = ["firstName", "lastName", "email", "phone"];

    for (const key of customerMandatoryFields) {
      const trimmedValue = formData[key] ? formData[key].trim() : "";

      if (!trimmedValue) {
        setCustomerValidation((prevState) => ({
          ...prevState,
          [key]: { InValid: true, text: "required" },
        }));

        valid = false;
      } else {
        setCustomerValidation((prevState) => ({
          ...prevState,
          [key]: { InValid: false, text: "" },
        }));
      }

      if (formData["email"]) {
        let result = validateEmail(formData.email);
        // console.log(result,'emaillllll');
        if (!result) {
          setCustomerValidation((prevState) => ({
            ...prevState,
            ["email"]: { InValid: true, text: "Invalid" },
          }));

          valid = false;
        } else {
          setCustomerValidation((prevState) => ({
            ...prevState,
            ["email"]: { InValid: false, text: "" },
          }));
        }
      }

      if (formData["phone"]) {
        let result = isValidPhoneNumber(formData.phone);
        // console.log(result,"number");
        if (!result) {
          setCustomerValidation((prevState) => ({
            ...prevState,
            ["phone"]: { InValid: true, text: "Invalid" },
          }));

          valid = false;
        } else {
          setCustomerValidation((prevState) => ({
            ...prevState,
            ["phone"]: { InValid: false, text: "" },
          }));
        }
      }
    }

    return valid;
  };
  const handleSave = async (e) => {
    e.preventDefault();
    setContinueClicked(true);
    let result = await checkValidation();
    // console.log(result, "rrrrr");
    if (result) {
      try {
        setLoading(true);
        // Loop through each key in formData
        for (const key in formData) {
          if (key !== "phone") {
            if (formData.hasOwnProperty(key)) {
              // Trim the value of each key
              formData[key] = formData[key].trim();
            }
          }
        }
        const apiUrl = `${config.baseUrl}/api/contact`;
        const response = await axios.post(apiUrl, formData);
        // console.log(response, "contactresponse");
        if (response?.data?.success) {
          router.push("/thank-you");
          // setShowModal(true);
          // setFormData({
          //   firstName: "",
          //   lastName: "",
          //   email: "",
          //   phone: "+1",
          //   company: "",
          //   message: "",
          // });
          // setCustomerValidation({
          //   firstName: { InValid: false, text: "" },
          //   lastName: { InValid: false, text: "" },
          //   email: { InValid: false, text: "" },
          //   phone: { InValid: false, text: "" },
          // });
        }
      } catch (error) {
        // console.log(error, "contacterror");
      } finally {
        setContinueClicked(false);
        setLoading(false);
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  return (
    <div>
      <div className="mx-auto max-w-7xl headerpxset">
        {home.map((object) => {
          return (
            <div
              key={object.image}
              id={style.mainheadersize}
              style={{
                display: "flex",
                alignItems: "flex-end",
                paddingBottom: "90",
              }}
              className={style[object.image]}
            >
              <div className=" mb-8 max-w-3xl  pl-6 sm:pl-4 md:pl-5 lg:pl-10">
                <h1 className="serviceh1 ">
                  CONTACT<span className="main_color"> US</span>
                </h1>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mx-auto max-w-7xl  lg:flex  lg:grid grid-cols-2">
        {/* ========================================= */}

        <div className="flex display-desktop justify-center grid grid-cols-12">
          <div className=" col-span-12 sm:col-span-12 md:col-span-11 lg:col-span-11 lg:-mt-16">
            <form
              onSubmit={(e) => {
                handleSave(e);
              }}
              className="master-shadow rounded-2xl bg-white px-7 pt-3 lg:-mt-72"
            >
              <div className=" flex gap-4 mb-3">
                <div className=" w-1/2 ">
                  <label
                    htmlFor="firstName"
                    for="firstName"
                    className="label-form"
                  >
                    First Name:
                  </label>
                  <CustomInputField
                    id="firstName"
                    name="firstName"
                    label="First Name"
                    placeholder=" Enter your first name"
                    value={formData.firstName}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    error={customerValidation.firstName}
                  />
                  {/* <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="Enter your first name"
                    className="mt-1 p-2 iinput rounded-md w-full"
                    required
                  /> */}
                </div>

                <div className="w-1/2 ">
                  <label
                    htmlFor="lastName"
                    for="lastName"
                    className="label-form"
                  >
                    Last Name:
                  </label>
                  <CustomInputField
                    id="lastName"
                    name="lastName"
                    label="Last Name"
                    placeholder="Enter your last name"
                    value={formData.lastName}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    error={customerValidation.lastName}
                  />
                  {/* <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Enter your last name"
                    className="mt-1 p-2 iinput rounded-md w-full"
                    required
                  /> */}
                </div>
              </div>

              <div className="mb-2">
                <label htmlFor="email" for="email" className="label-form">
                  Email Address:
                </label>
                <CustomInputField
                  id="email"
                  name="email"
                  label="Email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  error={customerValidation.email}
                />
                {/* <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email address"
                  className="mt-1 p-2 iinput outline-none rounded-md w-full"
                  required
                /> */}
              </div>

              <div className="mb-2 flex lg:flex-row flex-col gap-4">
                <div className="lg:w-1/2 w-full">
                  <label htmlFor="phone" for="phone" className="label-form">
                    Phone Number:
                  </label>
                  <PhoneInput
                    defaultCountry="us"
                    value={formData.phone}
                    onChange={handleChangePhone}
                  />
                  {/* <MuiPhoneNumber
                    className={`block w-full rounded-md inputBorder-style  px-3 py-2 ${
                      customerValidation.phone.InValid ? "numberError" : "" // Add red border if there is an error
                    }`}
                    value={formData.phone}
                    onChange={handleChangePhone}
                    defaultCountry={"us"}
                  /> */}

                  {customerValidation.phone.InValid && (
                    <p className="css-v7esy" style={{ color: "#d32f2f" }}>
                      Phone number is {customerValidation.phone.text}
                    </p>
                  )}
                  {/* <input
                    type="number"
                    id="phone"
                    name="phone"
                    className="mt-1 p-2 iinput rounded-md w-full"
                    placeholder="Enter your phone number"
                    required
                  /> */}
                </div>

                <div className="lg:w-1/2 w-full">
                  <label htmlFor="company" for="company" className="label-form">
                    Company:
                  </label>
                  <CustomInputField
                    id="company"
                    name="company"
                    label="Company"
                    placeholder=" Enter your company name"
                    value={formData.company}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                  {/* <input
                    type="text"
                    id="company"
                    name="company"
                    placeholder="Enter your company name"
                    className="mt-1 p-2 iinput rounded-md w-full"
                  /> */}
                </div>
              </div>

              <div>
                <div className="flex justify-between">
                  <label htmlFor="message" for="message" className="label-form">
                    How can we help you?
                  </label>
                  <p
                    style={{ color: "rgba(156, 163, 175, 1)" }}
                    className="text-grey text-xs flex items-end "
                  >
                    Max 1500 characters
                  </p>
                </div>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  className="mt-1 p-2 iinput rounded-md w-full h-44"
                  placeholder={`Please help us to understand:\n- Date of the trip\n- Route (Pickup & Drop-off locations)\n- Number of passengers and their luggage\n- Interested vehicle (e.g., Sedan, SUV, Van, Limousine)\n- If you need the driver to stay with you, mention the number of hours\n\n- Or any other question about our services.`}
                ></textarea>
              </div>

              <div className="mb-10 flex gap-7 pt-3 pb-4 flex font-sm justify-center">
                <button
                  type="submit"
                  className="buttoncolor font-semibold pr-12 pl-12 pt-2 rounded-md pb-2"
                >
                  {" "}
                  {loading === true ? (
                    <>
                      <BeatLoader size={10} color="#ffff" />
                    </>
                  ) : (
                    "Submit"
                  )}{" "}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* ======================================== */}
        <div className=" updatedparapremu px-4 lg:pt-4">
          <p className=" updatedparapremu pr-6">
            Thank you for considering{" "}
            <a id="highlight" style={{ fontWeight: "bolder" }} href="/">
              Prestige Ride
            </a>{" "}
            for your luxury transportation needs. We're here to provide
            first-class Black Car and{" "}
            <a
              style={{ color: "#D5AF34", textDecoration: "underline" }}
              href="/services/chauffeur-service"
            >
              Chauffeur Services
            </a>{" "}
            across the United States. Whether you're planning an Inter-City
            Luxury Commute,{" "}
            <a
              style={{ color: "#D5AF34", textDecoration: "underline" }}
              href="/services/corporate-airport-transfer"
            >
              Airport Transfers
            </a>
            , Corporate Travel, or any other transportation requirements, we are
            here to guide you through every step of the way.{" "}
          </p>
        </div>
        {/* ===================form here=============== */}

        <div className="flex display justify-center grid grid-cols-12">
          <div className=" col-span-12 sm:col-span-12 md:col-span-11 lg:col-span-11 lg:-mt-20 px-3">
            <form
              onSubmit={(e) => {
                handleSave(e);
              }}
              className="master-shadow rounded-2xl bg-white px-7 pt-3 lg:-mt-72"
            >
              <div className="flex flex-col lg:flex-row gap-4">
                <div className="w-full lg:w-1/2 mb-2">
                  <label
                    htmlFor="firstName"
                    for="firstName"
                    className="label-form"
                  >
                    First Name:
                  </label>
                  <CustomInputField
                    id="firstName"
                    name="firstName"
                    label="First Name"
                    placeholder=" Enter your first name"
                    value={formData.firstName}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    error={customerValidation.firstName}
                  />
                  {/* <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="Enter your first name"
                    className="mt-1 p-2 iinput rounded-md w-full"
                    required
                  /> */}
                </div>

                <div className="w-full lg:w-1/2  lg:mt-0">
                  <label
                    htmlFor="lastName"
                    for="lastName"
                    className="label-form"
                  >
                    Last Name:
                  </label>
                  <CustomInputField
                    id="lastName"
                    name="lastName"
                    label="Last Name"
                    placeholder="Enter your last name"
                    value={formData.lastName}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    error={customerValidation.lastName}
                  />
                  {/* <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Enter your last name"
                    className="mt-1 p-2 iinput rounded-md w-full"
                    required
                  /> */}
                </div>
              </div>

              <div className="mb-2">
                <label htmlFor="email" for="email" className="label-form">
                  Email Address:
                </label>
                <CustomInputField
                  id="email"
                  name="email"
                  label="Email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  error={customerValidation.email}
                />
                {/* <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email address"
                  className="mt-1 p-2 iinput outline-none rounded-md w-full"
                  required
                /> */}
              </div>

              <div className="mb-2 flex flex-col lg:flex-row gap-4">
                <div className="w-full lg:w-1/2">
                  <label htmlFor="phone" for="phone" className="label-form">
                    Phone Number:
                  </label>
                  <PhoneInput
                    defaultCountry="us"
                    value={formData.phone}
                    onChange={handleChangePhone}
                  />
                  {/* <MuiPhoneNumber
                    className={`block w-full rounded-md inputBorder-style  px-3 py-2 ${
                      customerValidation.phone.InValid ? "numberError" : "" // Add red border if there is an error
                    }`}
                    value={formData.phone}
                    onChange={handleChangePhone}
                    defaultCountry={"us"}
                  /> */}

                  {customerValidation.phone.InValid && (
                    <p className="css-v7esy" style={{ color: "#d32f2f" }}>
                      Phone number is {customerValidation.phone.text}
                    </p>
                  )}
                  {/* <input
                    type="number"
                    id="phone"
                    name="phone"
                    className="mt-1 p-2 iinput rounded-md w-full"
                    placeholder="Enter your phone number"
                    required
                  /> */}
                </div>

                <div className="w-full lg:w-1/2 lg:mt-0">
                  <label htmlFor="company" for="company" className="label-form">
                    Company:
                  </label>
                  <CustomInputField
                    id="company"
                    name="company"
                    label="Company"
                    placeholder=" Enter your company name"
                    value={formData.company}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                  {/* <input
                    type="text"
                    id="company"
                    name="company"
                    placeholder="Enter your company name"
                    className="mt-1 p-2 iinput rounded-md w-full"
                  /> */}
                </div>
              </div>

              <div>
                <div className="flex justify-between">
                  <label htmlFor="message" for="message" className="label-form">
                    How can we help you?
                  </label>
                  <p
                    style={{ color: "rgba(156, 163, 175, 1)" }}
                    className="text-grey text-xs flex items-end "
                  >
                    Max 1500 characters
                  </p>
                </div>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  className="mt-1 p-2 iinput rounded-md w-full h-44"
                  placeholder={`Please help us to understand:\n- Date of the trip\n- Route (Pickup & Drop-off locations)\n- Number of passengers and their luggage\n- Interested vehicle (e.g., Sedan, SUV, Van, Limousine)\n- If you need the driver to stay with you, mention the number of hours\n\n- Or any other question about our services.`}
                ></textarea>
              </div>

              <div className="mb-10 gap-7 pt-3 pb-4  font-sm">
                <ReCAPTCHA
                  sitekey={capaptha}
                  onChange={(val) => SetCapVal(val)}
                />

                <button
                  disabled={!capVal}
                  type="submit"
                  className="buttoncolor font-semibold pr-12 pl-12 pt-2 mt-3 rounded-md pb-2"
                >
                  {" "}
                  {loading === true ? (
                    <>
                      <BeatLoader size={10} color="#ffff" />
                    </>
                  ) : (
                    "Submit"
                  )}{" "}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="pt-6 mx-auto max-w-7xl flex justify-center   ">
        <Image src={map} className="px-10 pb-10" alt="contact map image" />
      </div>

      {/* thanku submitted modal */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showModal}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Submitted</Modal.Title>
        </Modal.Header>
        <Modal.Body>Thank you for submitted.</Modal.Body>
        <Modal.Footer>
          <button
            className="rounded-md bg-[#2B3252] hover:bg-[#d5af34] p-10 py-2.5 text-center text-base font-semibold text-white shadow-sm"
            onClick={handleCloseModal}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Homepage;
